export { TestimonialBase as Base, BaseText } from './Base';
export { BaseLogo, BaseContentSlot, BaseAuthorSlot } from './Base.views';